import { render, staticRenderFns } from "./tabbb.vue?vue&type=template&id=13d945b6&scoped=true&"
import script from "./tabbb.vue?vue&type=script&lang=js&"
export * from "./tabbb.vue?vue&type=script&lang=js&"
import style0 from "./tabbb.vue?vue&type=style&index=0&id=13d945b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d945b6",
  null
  
)

export default component.exports